module.exports = __webpack_public_path__ + "static/media/Facebook7.283e5276.png";